import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

const createMarkup = content => {
  return { __html: content };
};

const Crumb = styled.div.attrs({})`
  font-family: Nunito;
  font-size: 0.75rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  a {
    text-decoration: none;
    color: #aaaaaa;
  }
`;

const Breadcrumb = props => {
  const { history } = props;
  const contentClickHandler = e => {
    const targetLink = e.target.closest('a');
    if (!targetLink) return;
    e.preventDefault();
    e.stopPropagation();

    if (targetLink.hostname === window.location.hostname) {
      // This is an Internal Link
      let x = targetLink.pathname;
      if (x.slice(-1) === '/') {
        x = x.slice(0, -1);
      }
      history.replace({ pathname: x, state: `change` });
    } else {
      // This is an External Link
      window.open(targetLink.href, '_blank');
    }

    // console.log(targetLink.href);
    // // targetLink.pathname;
    // console.log(targetLink.href.slice(21));

    // history.push(e.target.href.slice(21));

    // console.log('targetLink.protocol: ', targetLink.protocol);
    // console.log('targetLink.host: ', targetLink.host);
    // console.log('targetLink.hostname: ', targetLink.hostname);
    // console.log('targetLink.port: ', targetLink.port);
    // console.log('targetLink.pathname: ', targetLink.pathname);
    // console.log('targetLink.hash: ', targetLink.hash);
    // console.log('targetLink.search: ', targetLink.search);
  };

  return (
    <Crumb
      className="Breadcrumb mb2"
      onClick={contentClickHandler}
      dangerouslySetInnerHTML={createMarkup(props.crumb)}
    />
  );
};

export default withRouter(Breadcrumb);
